import { NotificationInboxDestroyRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'

export const NotificationInboxDestroy = (_context: NoContext) =>
  NotificationInboxDestroyRequestSchema
